module.exports = __webpack_public_path__ + "img/BAU Seniors_2.69fe9ff6.jpg";